<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>用户资金明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col
            :span="5"
            class="display-row"
          >
            <div class="query-title">交易开始日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.createTimeStart"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="5"
            class="display-row"
          >
            <div class="query-title">交易结束日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.createTimeEnd"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="5"
            class="display-row"
          >
            <div
              class="query-title"
              style="text-align:right"
            >交易编号:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.tradingNo"
                size="small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col
            :span="5"
            class="display-row"
          >
            <div
              class="query-title"
              style="text-align:right"
            >用户ID:</div>
            <div class="flex1">
              <!--<el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.userName"
                size="small"
                @keyup.enter.native="searchList"
              >
              </el-input>-->
              <search-user-id v-model="queryInfo.userName"></search-user-id>
            </div>
          </el-col>
          <el-col
            :span="4"
            class="display-row"
          >
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button
                class="search-btn btn-gray"
                @click="queryInfoClear"
              >重置</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="searchList"
              >搜索</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
        <div class="bill_top">
          <span class="tk-title">用户余额总额：<i>{{customerBalance}}</i>元</span>
        </div>
      </div>
      <div
        slot="table"
        class="full-height display-col"
      >
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="recordList"
          border
          height="550"
          :row-style="{height: '40px'}"
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="40"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="tradingNo"
            align="center"
            label="交易编号"
          >
          </el-table-column>
          <el-table-column
            prop="orderNo"
            align="center"
            label="关联订单号"
          >
          </el-table-column>
          <el-table-column
            prop="dealDesc"
            align="center"
            label="交易说明"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            sortable
            align="center"
            :index="indexMethod"
            label="交易时间"
          >
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column
            prop="typeDetail"
            :index="indexMethod"
            sortable
            align="center"
            label="交易类型"
          >
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.typeDetail) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="money"
            :index="indexMethod"
            sortable
            align="center"
            label="金额"
          >
            <template v-slot="scope">
              {{ moneyShow(scope.row.moneyFlag, scope.row.money) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="balance"
            :index="indexMethod"
            sortable
            align="center"
            label="余额"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  data () {
    return {
      queryInfo: {
        userName: '',
        tradingNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      customerBalance: 0,
    }
  },
  methods: {
    // 导出
    async exportAction () {
      this.$http({
        url: 'cms/capitalRecord/userListExport',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '用户资金明细.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取客户余额
    getCustomerBalance () {
      this.$http.get("cms/capitalRecord/customer/balance").then(res => {
        if (res.data.code === 200) {
          this.customerBalance = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
      this.getCustomerBalance();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
      this.this.getCustomerBalance();
    },
    orderDateRange () {

    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getCustomerBalance();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('cms/capitalRecord/userList', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        tradingNo: '',
        userName: '',
        pageSize: 10,
        pageNum: 1
      }
      this.orderDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return '充值'
          break;
        case '2':
          return '装箱单付款'
          break;
        case '3':
          return '订单付款'
          break;
        case '4':
          return '赔偿'
          break;
        case '5':
          return '扣款'
          break;
        case '6':
          return '退金（提现）'
          break;
        case '7':
          return '购买完扣费'
          break;
        case '8':
          return '退货退费'
          break;
        case '9':
          return '异常扣费'
          break;
        case '10':
          return '同捆付款'
          break;
        case '11':
          return '仓库保管费'
          break;
        case '12':
          return '检品完扣费'
          break;
        case '13':
          return '取消购买退费'
          break;
        case '14':
          return '取消检品退费'
          break;
        case '15':
          return '换货检品费'
          break;
        case '99':
          return '会员费扣费'
          break;
        case '100':
          return '充值手续费'
          break;
      }
    },
    moneyShow (moneyFlag, money) {
      switch (moneyFlag) {
        case '1':
          return '+' + money
          break;
        case '0':
          return '-' + money
          break;
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }

    }
  },
  created () {
    this.getrecordList();
    this.getCustomerBalance();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.bill_top {
  // width: 100%;
  height: 20px;
  margin: 10px;
  padding-right: 15px;
  padding-top: 15px;
  float: right;
}
.bill_top span {
  display: block;
  float: left;
  margin-left: 20px;
}
.bill_top i {
  text-decoration: underline;
  color: black;
  font-style: normal;
  padding-right: 5px;
}
.tk-title {
  color: #999999;
}
</style>
